@use "variables" as *;

.discountBox {
  border-radius: 4px;
  font-size: $fontSize-xxxs;
  font-weight: bold;
  display: flex;
  align-items: center;
  padding-left: $spacing-xs;
  padding-right: $spacing-xs;
  height: 16px;
  align-self: center;
}
